import {
  ALIMTALK_SEND_STATUS,
  ALIMTALK_SEND_TYPE,
  AlimtalkSendHistorySearchType,
  AlimtalkSendStatus,
  AlimtalkSendType,
} from './types';

/** 페이지 제목 (PageTemplate pageName) */
export const ALIMTALK_SEND_PAGE_NAME = {
  HISTORY_LIST: '알림톡 발송 내역',
  HISTORY_DETAIL: '알림톡 발송 상세정보',
} as const;

/** 기본 페이지 크기 (스펙 기본값 20) */
export const ALIMTALK_SEND_HISTORY_DEFAULT_PAGE_SIZE = 20;

/** 페이지 크기 선택지 (테이블 페이저와 같은 값 — 백엔드 pageSize 최대 100) */
export const ALIMTALK_SEND_HISTORY_PAGE_SIZE_OPTIONS = [20, 50, 100] as const;

/** 목록 page 최대값 (스펙: 최대 100,000) */
export const ALIMTALK_SEND_HISTORY_MAX_PAGE = 100_000;

/**
 *  Worker 가 상태를 바꾸는 중인 상태 — 화면을 열어 둔 채로도 결과가 보이도록 이 상태가 있을 때만 자동 갱신한다.
 *  (완료·실패·취소됨 등 끝난 상태만 있으면 갱신하지 않는다)
 */
export const ALIMTALK_SEND_IN_PROGRESS_STATUSES: readonly AlimtalkSendStatus[] = [
  ALIMTALK_SEND_STATUS.PENDING,
  ALIMTALK_SEND_STATUS.RUNNING,
  ALIMTALK_SEND_STATUS.CANCELLING,
];

/** 진행 중 상태가 있을 때의 자동 갱신 주기 */
export const ALIMTALK_SEND_HISTORY_AUTO_REFRESH_INTERVAL_MS = 15_000;

/** 상태 → 화면 표시 라벨 */
export const ALIMTALK_SEND_STATUS_LABEL: Record<AlimtalkSendStatus, string> = {
  [ALIMTALK_SEND_STATUS.PENDING]: '예약됨',
  [ALIMTALK_SEND_STATUS.RUNNING]: '발송중',
  [ALIMTALK_SEND_STATUS.CANCELLING]: '취소 요청됨',
  [ALIMTALK_SEND_STATUS.COMPLETED]: '완료',
  [ALIMTALK_SEND_STATUS.FAILED]: '실패',
  [ALIMTALK_SEND_STATUS.CANCELLED]: '취소됨',
  [ALIMTALK_SEND_STATUS.TEST_COMPLETED]: '테스트 발송 완료',
};

/** 상태 → antd Tag 색상 */
export const ALIMTALK_SEND_STATUS_TAG_COLOR: Record<AlimtalkSendStatus, string> = {
  [ALIMTALK_SEND_STATUS.PENDING]: 'blue',
  [ALIMTALK_SEND_STATUS.RUNNING]: 'processing',
  [ALIMTALK_SEND_STATUS.CANCELLING]: 'orange',
  [ALIMTALK_SEND_STATUS.COMPLETED]: 'green',
  [ALIMTALK_SEND_STATUS.FAILED]: 'red',
  [ALIMTALK_SEND_STATUS.CANCELLED]: 'default',
  [ALIMTALK_SEND_STATUS.TEST_COMPLETED]: 'purple',
};

/** 발송 유형 → 화면 표시 라벨 */
export const ALIMTALK_SEND_TYPE_LABEL: Record<AlimtalkSendType, string> = {
  [ALIMTALK_SEND_TYPE.CSV]: '알림톡 단독 발송',
  [ALIMTALK_SEND_TYPE.ISSUE_COUPON_ONLY]: '쿠폰 발급만',
  [ALIMTALK_SEND_TYPE.ISSUE_COUPON]: '쿠폰 발급 알림',
  [ALIMTALK_SEND_TYPE.EXPIRE_COUPON]: '쿠폰 만료 알림',
};

interface SelectOption<T> {
  label: string;
  value: T;
}

const ALL_VALUE = '' as const;

/**
 *  조회 기준 select.
 *  상세 API 가 scheduledAt(예약일시) 기준 단일 검색만 제공하므로 옵션은 1개다.
 */
export const ALIMTALK_SEND_DATE_BASIS_OPTIONS: SelectOption<'scheduledAt'>[] = [
  { label: '예약일 기준', value: 'scheduledAt' },
];

/** 상태 필터 옵션 (전체 + 스펙 상태 전체) */
export const ALIMTALK_SEND_STATUS_FILTER_OPTIONS: SelectOption<AlimtalkSendStatus | typeof ALL_VALUE>[] = [
  { label: '전체', value: ALL_VALUE },
  ...(Object.values(ALIMTALK_SEND_STATUS).map((status) => ({
    label: ALIMTALK_SEND_STATUS_LABEL[status],
    value: status,
  })) as SelectOption<AlimtalkSendStatus>[]),
];

/** 발송 유형 필터 옵션 (전체 + 스펙 유형 전체) */
export const ALIMTALK_SEND_TYPE_FILTER_OPTIONS: SelectOption<AlimtalkSendType | typeof ALL_VALUE>[] = [
  { label: '전체', value: ALL_VALUE },
  ...(Object.values(ALIMTALK_SEND_TYPE).map((sendType) => ({
    label: ALIMTALK_SEND_TYPE_LABEL[sendType],
    value: sendType,
  })) as SelectOption<AlimtalkSendType>[]),
];

/** 검색 유형 옵션 */
export const ALIMTALK_SEND_SEARCH_TYPE_OPTIONS: SelectOption<AlimtalkSendHistorySearchType>[] = [
  { label: '예약 ID', value: 'scheduleId' },
  { label: '메모', value: 'memo' },
  { label: '등록자', value: 'adminName' },
];
